export const market_names = [
  "Algeria",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahrain",
  "Belgium",
  "Benin",
  "Botswana",
  "Brazil",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central Africa Republic",
  "Chad",
  "China",
  "CMS :  Greece",
  "CMS :  Romania",
  "CMS : Belgium",
  "CMS : Czech Republic",
  "CMS : Denmark",
  "CMS : Estonia",
  "CMS : France",
  "CMS : Germany",
  "CMS : Greece",
  "CMS : Hungary",
  "CMS : Ireland",
  "CMS : Italy",
  "CMS : Lithuania",
  "CMS : Luxemburg",
  "CMS : Morocco",
  "CMS : Netherlands",
  "CMS : Nigeria",
  "CMS : Poland",
  "CMS : Portugal",
  "CMS : Romania",
  "CMS : Slovak Republic",
  "CMS : Spain",
  "CMS : Sweden",
  "CMS : United Kingdom",
  "CMS: Romania",
  "CMS: Spain",
  "Congo",
  "Crossland",
  "Czech Republic",
  "Denmark",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "Emerging",
  "Ethiopia",
  "Europe",
  "Finland",
  "France",
  "France (Sandoz) (National) (200 mg)",
  "France-National (EVOLUGENPHARMA)",
  "FWA",
  "Gabon",
  // "\"GCC Countries (Oman, United Arab Emirates(UAE), Kuwait, Saudi Arabia, Qatar, Yemen, Bahrain)\"",
  "Georgia",
  "Germany",
  // "\"Germany - MRP countries (Germany, Austria, Belgium, Portugal, Luxembourg, Spain)\"",
  // "Germany (MAH: Mylan Dura) (200mg/400 mg)",
  // "Germany (National) (100 mg)",
  // "Germany National (MAH: Aluid and Stada) (100 mg/200 mg/400 mg)",
  // "Germany National (MAH:Mylan Dura) 100 mg",
  "Ghana",
  "Greece",
  "Guinea",
  "Hungary",
  "Hungary (200 mg)",
  "India",
  "Iraq",
  "Ireland",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Kazakhstan",
  "Kenya",
  "Kyrgyzstan",
  "Latvia",
  "Lebanon",
  "Lithuania",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Mali",
  "Malta",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "National Filing - Morocco",
  "Nepal",
  "Netherlands",
  "Niger",
  "Nigeria",
  "Oman",
  "Peru",
  "Pharma",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "R D Congo",
  "RE II",
  "RMS : Netherlands",
  "RMS : United Kingdom",
  "RMS: Germany",
  "RMS: Sweden",
  "ROA",
  "Romania",
  "ROW",
  "Russia",
  "Rwanda",
  "SAFR",
  "Saudi",
  "Senegal",
  "Singapore",
  "Slovak",
  "South Africa",
  "Spain",
  "Spain (combix) (National) (200 mg)",
  "Sri Lanka",
  "Sudan",
  "Sweden",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Trinidad & Tobago",
  "UAE",
  "Uganda",
  "Ukraine",
  "United Kingdom",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "WHO",
  "Zambia",
  "Zimbabwe",
];

export const order_types = [
  "ZD10",
  "ZD20"
];

export const stor_loc_options = [
  "2101",
  "2102",
  "2103",
  "2104",
];

export const unit_types = [
  "EA",
  "KG"
];

export const sample_types = [
  // { label: "SFG(with micro)", value: "SFG(with micro)" },
  { label: "SFG(without micro)", value: "SFG(without micro)" },
  { label: "FP(with micro)", value: "FP(with micro)" },
  { label: "FP(without micro)", value: "FP(without micro)" },
  {
    label: 'CB(urgent)',
    value: 'CB(urgent)'
  },
  {
    label: 'CB',
    value: 'CB'
  },
  {
    label: 'CB(additional)',
    value: 'CB(additional)'
  }
];

export const po_columns = {
  "pr.superv.": {
    type: "number",
    isEditable: false
  },
  "material": {
    type: "text",
    isEditable: false,
  },
  "material_description": {
    type: "text",
    isEditable: false,
  },
  "order_type": {
    type: "select",
    isEditable: false,
    options: order_types.map((name) => ({ label: name, value: name }))
  },
  "order": {
    type: "text",
    isEditable: false,
  },
  "batch_no": {
    type: "text",
    isEditable: false,
  },
  "group": {
    type: "text",
    isEditable: false,
  },
  "system_status": {
    type: "text",
    isEditable: false,
  },
  "release": {
    type: "date",
    isEditable: false,
  },
  "target_qty": {
    type: "number",
    isEditable: true
  },
  "del._qty": {
    type: "number",
    isEditable: false,
  },
  "unit": {
    type: "select",
    isEditable: false,
    options: unit_types.map((name) => ({ label: name, value: name })),
  },
  "stor._loc.": {
    type: "select",
    isEditable: false,
    options: [...stor_loc_options].map((name) => ({ label: name, value: name })),
  },
  "expected_delivery_date_by_production": {
    type: "date",
    isEditable: true,
  },
  "spec_id": {
    type: "text",
    isEditable: true,
  },
  "stp_id": {
    type: "text",
    isEditable: true,
  },
  "market": {
    type: "select",
    isEditable: true,
    options: [...market_names].map((name) => ({ label: name, value: name })),
  },
  "sample_type": {
    type: "select",
    isEditable: true,
    options: JSON.parse(JSON.stringify(sample_types))
  },
  "expected_delivery_date_by_ip_qa": {
    type: "date",
    isEditable: true,
  },
  // "receiving_date_by_qc": {
  //   type: "date",
  //   isEditable: true,
  // },
  "lot_creation_date": {
    type: "date",
    isEditable: true,
  },
};

